export default __webpack_public_path__ + "281ca14174e36b8354f7b09e2499f504.svg";